import React, {useEffect, useState} from 'react';
import { BreadcrumbsModule } from 'polisua-react-modules/index.esm';
import { useHistory, useLocation } from  'react-router-dom';
import LocalizedStrings from 'react-localization';
import * as url from 'url';

const BreadcrumbsWrapper = (props) => {
  const [ currentCrumb, setCurrentCrumb ] = useState('');
  const { locale } = props;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const strings = new LocalizedStrings({
    ru: {
      offers: 'Выбор компании',
      package: 'Выбор программы',
      compare: 'Лист сравнения',
      anketa: 'Персональные данные',
      carForm: 'Данные авто',
      driverForm: 'Дополнительные данные',
    },
    ua: {
      offers: 'Вибір компанії',
      package: 'Вибір програми',
      compare: 'Лист порівняння',
      anketa: 'Персональні дані',
      carForm: 'Дані авто',
      driverForm: 'Додаткові дані',
    },
  });
  strings.setLanguage(locale);
  const crumbs = [
    {
      url: '/kasko/list',
      title: strings.offers
    },
    {
      url: '/kasko/info',
      title: strings.package
    },
    {
      url: '/kasko/compare',
      title: strings.compare
    },
    {
      url: '/kasko/apply',
      title: strings.anketa
    },
  ];
  const initCrumbs = () => {
    const searchCrumb = crumbs.filter((el) => pathname.includes(el.url));
    if (searchCrumb.length) return setCurrentCrumb(searchCrumb[0].title);
    if (!searchCrumb.length && search.includes('step=2')) return setCurrentCrumb(strings.carForm);
    if (!searchCrumb.length && search.includes('step=3')) return setCurrentCrumb(strings.driverForm);
    setCurrentCrumb('');
  };
  const handlePush = (url) => {
    window.location.href = url;
  };

  useEffect(() => {
    initCrumbs();
  }, [pathname, search]);

  return (
    <div className="breadcrumbs-wrapper">
      <BreadcrumbsModule
        historyPushFunc={handlePush}
        lang={locale === 'ua' ? 'uk' : 'ru'}
        projectUrl={locale === 'ua' ? '/uk/kasko' : '/kasko'}
        projectTitle="КАСКО"
        currentStepTitle={currentCrumb}
      />
    </div>
  );
}

export default BreadcrumbsWrapper;
